const root = 'https://docs.wandb.ai';

// Use this directly if you know the name of the docUrl you want.
const DOC_URLS = {
  artifacts: root + '/models/artifacts',
  artifactAutomations:
    root +
    '/models/automations/create-automations/webhook#create-a-webhook-automation',
  artifactTTL: root + '/models/artifacts/ttl',
  automation: root + '/models/automations',
  codeComparer: root + '/models/app/features/panels/code#code-comparer',
  codeSaving: root + '/models/app/features/panels/code',
  compareMetrics: root + '/models/app/features/panels/line-plot',
  config: root + '/models/track/config',
  createQueue: root + '/platform/launch/create-launch-job#create-a-launch-job',
  customCharts: root + '/models/app/features/custom-charts',
  defineMetric: root + '/models/track/log#customize-the-summary',
  domainCapture:
    root +
    '/platform/hosting/iam/access-management/manage-organization/#domain-capture',
  gettingStarted: root + '/quickstart',
  launch: root + '/platform/launch/set-up-launch',
  launchPublicQueue: root + '/models/launch',
  launchJobs: root + '/platform/launch/create-launch-job#create-a-launch-job',
  launchJobsCreate:
    root + '/platform/launch/create-launch-job#create-a-launch-job',
  launchKubernetes: root + '/platform/launch/setup-launch-kubernetes',
  launchSageMakerAgentConfiguration:
    root +
    '/platform/launch/setup-launch-sagemaker#tutorial-set-up-w-and-b-launch-on-sagemaker',
  launchVertex: root + '/platform/launch/setup-vertex',
  logs: root + '/models/track/log',
  logsDistributedSingleRun:
    root +
    '/models/track/log/distributed-training/#track-all-processes-to-a-single-run',
  modelRegistry: root + '/models/registry',
  models: root + '/models',
  multiMetricQuickAdd:
    root +
    '/models/app/features/panels/line-plot#more-about-multi-metric-regular-expressions',
  parameterImportance:
    root + '/models/app/features/panels/parameter-importance',
  'query-panel': root + '/models/app/features/panels/query-panels/',
  publicApi: root + '/models/ref/python/public-api',
  pythonApi: root + '/models/ref/python/public-api',
  registry: root + '/models/registry',
  reports: root + '/models/reports',
  root,
  save: root + '/models/track/save-restore',
  serviceAccounts: root + '/platform/hosting/iam/service-accounts',
  summaryMetric: root + '/models/track/log#summary-metrics',
  sweeps: root + '/models/sweeps',
  sweepsOnLaunch: root + '/platform/launch/sweeps-on-launch',
  teams: root + '/platform/app/settings-page/teams',
  userSettings: root + '/platform/app/settings-page/user-settings',
  weave: root + '/weave/guides/tools/weave-in-workspaces#use-weave-panels',
  'weave-table': root + '/models/tables',
  weaveProduct:
    'https://wandb.github.io/weave/?utm_source=app&utm_medium=app&utm_campaign=weave-nudge',
};

// Use this if you need an index lookup
export function lookupDocUrl(name: string) {
  return (DOC_URLS as {[key: string]: string | undefined})[name];
}

export default DOC_URLS;
